import React, { useState } from 'react';
import Header from './Header';
import Nav from './Nav';
import Main from './Main';
import Footer from './Footer';
import db from '../db/store.json';

const Template = () => {
  const [store, setStore] = useState(db);
  const [typename, setTypename] = useState('');
  const [keyword, setKeyword] = useState('');

  const onSelect = (e) => {
    const text = e.target.innerText;
    setTypename(text);
    setKeyword('');
    if (text === '전체') {
      setStore(db);
    }
  };

  const onChange = (e) => {
    const val = e.target.value;
    if (val.length > 1) {
      const keywordStore = db.filter((el) => el['name'].indexOf(val) > -1);
      setKeyword(val);
      setStore(keywordStore);
    } else {
      setKeyword(val);
      setStore(db);
    }
  };

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <Header onChange={onChange} />
      <Nav onSelect={onSelect} />
      <Main store={store} keyword={keyword} typename={typename} />
      <Footer />
    </div>
  );
};

export default Template;
